module.exports = __webpack_public_path__ + "static/media/6.3f0dae87.JPG";